import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// Routes that need non-standard layouts
// 'minimal' = no sidebar, stripped navbar (next-call, chat pages)
const LAYOUT_MODE_MAP = {
  '/next-call': 'minimal',
  '/next-call-v2': 'minimal',
  '/chat': 'minimal',
};

const useLayoutMode = () => {
  const { pathname } = useLocation();
  return useMemo(() => {
    for (const [route, mode] of Object.entries(LAYOUT_MODE_MAP)) {
      if (pathname === route || pathname.startsWith(route + '/')) return mode;
    }
    return 'default';
  }, [pathname]);
};

export default useLayoutMode;
